import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Layout from "../components/Layout"
import Hero from "../components/Hero"
import Jobs from "../components/Jobs"
import Projects from "../components/Projects"
import Blogs from "../components/Blogs"
import SEO from '../components/SEO'
import Timeline from "../components/Timeline"
const query = graphql`
  {
    __typename
    allStrapiProjects(filter: { featured: { eq: true } }) {
      nodes {
        description
        github
        id
        title
        stack {
          id
          title
        }
        image {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        url
      }
    }
    allStrapiBlogs(sort: { fields: description, order: DESC }, limit: 3) {
      nodes {
        slug
        title
        description
        id
        date(formatString: "DD-MM-YYYY")
        image {
          childImageSharp {
            fluid {
              src
            }
          }
        }
        category
        content
      }
    }
  }
`

export default () => {
  const {
    allStrapiProjects: { nodes: projects },
    allStrapiBlogs: { nodes: blogs },
  } = useStaticQuery(query)
  return (
    <Layout>
      <SEO title="Home" description='Welcome to the Home Page'/>
      <Hero />
      <Timeline />
      <Jobs />
      <Projects
        projects={projects}
        title="Featured Project"
        isShowMoreEnabled={true}
      />
      <Blogs blogs={blogs} title='Latest Articles' isLinkEnabled={true}/>
    </Layout>
  )
}
